import MuiTablePagination, {
  type TablePaginationProps as MuiTablePaginationProps,
} from '@mui/material/TablePagination';
import { table as tableTokens } from '@/shared/theme/tokens';
import { mergeSx } from '../utils/mergeSx';
import { LIST_ROWS_PER_PAGE_OPTIONS } from './listPagination';

export type TablePaginationProps = MuiTablePaginationProps;

const TablePagination = ({
  sx,
  rowsPerPageOptions = LIST_ROWS_PER_PAGE_OPTIONS,
  ...props
}: TablePaginationProps) => (
  <MuiTablePagination
    rowsPerPageOptions={rowsPerPageOptions}
    sx={mergeSx(
      {
        border: 0,
        '& .MuiToolbar-root': {
          // Override global MuiToolbar height (appBarHeight) without changing AppBar.
          minHeight: tableTokens.paginationMinHeight,
          height: tableTokens.paginationMinHeight,
          py: 0,
          px: 0,
        },
        '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
          fontSize: tableTokens.paginationFontSize,
          my: 0,
        },
        '& .MuiInputBase-root': {
          fontSize: tableTokens.paginationFontSize,
        },
        '& .MuiTablePagination-actions .MuiIconButton-root': {
          padding: tableTokens.paginationIconPadding,
        },
      },
      sx,
    )}
    {...props}
  />
);

export default TablePagination;
